<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <v-row class="py-2 pl-1 mx-4" align="center" justify="space-between">
        <h4 class="kbDarkBlueText--text" style="display: inline;" id="title">{{$t('general.dailyUsage')}}</h4>
        <v-btn color="kbLightBlue"
               dark
               :loading="downloading"
               @click="downloadTransactions()">
          <v-icon small left>fas fa-file-excel</v-icon>
            {{$t('general.report')}}
        </v-btn>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-data-table
        :must-sort="false"
        :headers="headers"
        :items="usage"
        class="elevation-2"
        :loading="loadingUsage"
        :options.sync="options"
        :footer-props="{
          'items-per-page-text': $t('general.recordsPerPage'),
          'items-per-page-options': [50, 100, 200]
        }"
        :server-items-length="totalUsage">
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="kbDarkBlueText"
                    v-on="on"
                  >{{ getIconType(item.chargeType) }}</v-icon>
                </template>
                <span style="text-transform: capitalize">{{item.chargeType}}</span>
              </v-tooltip>
            </td>
            <td class="font-weight-bold">{{ item['payments__charge_type.label'] ? item['payments__charge_type.label'] : item.chargeType }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.amount | toFixed(4) }}</td>
            <td>{{item.date | nullToDateNow | moment('DD/MM/YYYY')}}</td>

            <td class="px-0 mx-0">
              <div class="data-table-actions d-flex justify-center align-center">
                <v-btn icon @click="showTransaction(item)" color="kbDarkBlueText" text>
                  <v-icon color="kbDarkBlueText">remove_red_eye</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-row>
            <v-col class="text-center" cols="12" v-if="loadingUsage">{{$t('general.loadingRecords')}}</v-col>
            <v-col cols="12" class="red--text text-center" v-else>{{$t('general.noMovementsRecords')}}</v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
    <DetailedUsage />
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import messageTypes from '@/libs/messageTypes'
import DetailedUsage from '@/pages/App/Billing/DetailedUsage.vue'
import notifications from '@/libs/notifications'
export default {
  created () {
    this.getUsage()
  },
  components: { DetailedUsage },
  computed: {
    ...mapState({
      usage: state => state.payments.dailyUsage,
      loadingUsage: state => state.payments.loadingDailyUsage,
      totalUsage: state => state.payments.totalDailyUsage,
      selectedCompany: state => state.companies.selectedCompany
    }),
    headers () {
      return [
        { text: '', align: 'left', value: 'chargeType' },
        { text: this.$t('general.service'), align: 'left', value: 'description' },
        { text: this.$t('general.amount'), align: 'left', value: 'quantity' },
        { text: this.$t('general.value'), align: 'left', value: 'amount' },
        { text: this.$t('general.date'), value: 'date' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  data () {
    return {
      downloading: false,
      options: {},
      getIconType: messageTypes.getIconType
    }
  },
  methods: {
    async downloadTransactions () {
      try {
        this.downloading = true
        await this.$store.dispatch('getTransactionMovements')
        this.downloading = false
        notifications.success(this.$t('general.successfullyMovementsReportDownloaded'))
      } catch (e) {
        this.downloading = false
        console.error(e)
      }
    },
    getUsage () {
      this.$store.commit('SET_PAGINATION_DAILY_USAGE', {
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        sortBy: this.options.sortBy ? this.options.sortBy[0] : '',
        descending: this.options.sortDesc ? this.options.sortDesc[0] : ''
      })

      this.$store.dispatch('getDailyUsage')
    },
    showTransaction (item) {
      this.$store.commit('SET_SEARCH_DETAILED_USAGE', item)
      this.$store.commit('TOGGLE_DETAILED_USAGE_DIALOG', true)
    }
  },
  watch: {
    options: {
      handler () {
        this.getUsage()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    selectedCompany (value) {
      if (value) {
        this.getUsage()
      }
    }
  }
}
</script>
